import { AxiosError, AxiosResponse } from 'axios';
import { FetchResult, instance } from './config';
import { useMutation } from '@tanstack/react-query';
import { IImageGenerateResponse } from '@types';

async function postImageGenerate(variables: {
  body: FormData;
}): Promise<AxiosResponse<FetchResult<IImageGenerateResponse>>> {
  const response = await instance.post(`/ai/model-to-character`, variables.body);
  return response;
}

const usePostImageGenerate = (
  onSuccess?: (data: AxiosResponse<FetchResult<IImageGenerateResponse>>) => void,
  onError?: (err: AxiosError) => void
) => {
  const { mutateAsync, isPending, data } = useMutation({
    mutationKey: ['post', '/ai/model-to-character`'],
    mutationFn: (variables: { body: FormData }) => postImageGenerate(variables),
    onSuccess: (data) => {
      onSuccess?.(data);
    },
    onError: (err: AxiosError) => {
      onError?.(err);
    },
    retry: false
  });

  return { mutateAsync, isPending, data };
};

export default usePostImageGenerate;
